import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProjectNewService } from '../../service/project-new.service';

@Component({
  selector: 'apc-project-creation-success',
  templateUrl: './project-creation-success.component.html',
  styleUrls: ['./project-creation-success.component.scss', '../../project-management.component.scss'],
})
export class ProjectCreationSuccessComponent implements OnInit {
  @Input() modalRef: any;
  @Input() projectUrl: string;
  @Input() projectDataUrl: string;
  @Input() userManagementUrl: string;
  @Input() projectName: string;
  @Input() projectKey: string;
  @Input() workspaceResourceUrl: string;
  public visitedElem = [];
  public visitedElementSubscription: any;
  constructor(public projectNewService: ProjectNewService, private modalService: NgbModal) { }

  ngOnInit(): void {
    this.projectNewService._visitedElem$.subscribe((element) => {
      if (element != null) {
        this.manageCheckInStorage(this.projectKey, element, this.visitedElem);
      }
    });
  }


  close() {
    this.modalService.dismissAll();
    sessionStorage.removeItem(this.projectKey);
    //To fix because subscription _triggerFunnelDetail$ is triggered more than once (also for sendMailcomponent)
  }

  goTo(url, section) {
    window.open(url, '_blank');
    this.manageCheckInStorage(this.projectKey, section, this.visitedElem);
  }

  manageCheckInStorage(projectKey, section, visitedElem) {
    let sessionElements = sessionStorage.getItem(projectKey);
    if (sessionElements === null) {
      visitedElem.push(section);
      sessionStorage.setItem(projectKey, JSON.stringify(visitedElem));
    } else {
      let sessionElementsParsed = JSON.parse(sessionElements);
      if (sessionElementsParsed.includes(section) === false) {
        sessionElementsParsed.push(section);
      }
      sessionStorage.setItem(projectKey, JSON.stringify(sessionElementsParsed));
    }
  }

  triggerDetailsModal() {
    this.projectNewService._triggerFunnelDetail$.next(true);
    this.modalService.dismissAll();
  }

  isChecked(section) {
    let sessionElements = sessionStorage.getItem(this.projectKey);
    if (sessionElements != null) {
      let sessionElementsParsed = JSON.parse(sessionElements);
      return sessionElementsParsed.includes(section);
    }
  }

}
